// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2mG1i","label":"Labeled_label__1vquD","divider":"Labeled_divider__2Buwj"};